import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { BoardComponent } from './components/board/board.component';
import { MainComponent } from './components/main/main.component';
import { AddrequestComponent } from './components/addrequest/addrequest.component';
import { AuthGuard } from './guards/auth.guard';
import { AddrequestGuard } from './guards/addrequest.guard';
import { HomeauthGuard } from './guards/homeauth.guard';
import { ProfileComponent } from './components/profile/profile.component';
import { ChangepasswordComponent } from './components/changepassword/changepassword.component';
import { ResetpasswordComponent } from './components/resetpassword/resetpassword.component';
const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {path:'' , redirectTo:'board/main', pathMatch:'full' , canActivate: [AuthGuard]},
  {path:'board' , redirectTo:'board/main', pathMatch:'full'},
  {path:'home' , component:HomeComponent ,canActivate: [HomeauthGuard]},
  {path:'reset' , component:ResetpasswordComponent },
  {path:'board' , component:BoardComponent,canActivate: [AuthGuard],children:[
    {path: '', component:HomeComponent},
    {path: 'main', component:MainComponent},
    {path: 'addrequest', component:AddrequestComponent , canActivate: [AddrequestGuard]},
    { path: "addrequest/:id/:tenantId", component: AddrequestComponent },
    { path: "addrequest/:id/:tenantId/:view", component: AddrequestComponent},
    {path: 'profile', component:ProfileComponent},
    {path: 'password', component:ChangepasswordComponent},
  ]},
  {path:'**' , redirectTo:'board/main', pathMatch:'full'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { 

}
